import request from "@/utils/request";
/*---------------------------系统配置接口相关-----------------------------------*/
// 获取设备类型
export function getDeviceTypeList(params) {
    return request({
        url: "/api/system/device-type/",
        method: "get",
        params: params
    })
}

// 获取系统版本内容
export function getVersionList(params) {
    return request({
        url: "/api/system/version/",
        method: "get",
        params: params
    })
}

// 获取语言内容
export function getLangData(params) {
    return request({
        url: "/api/system/lang/",
        method: "get",
        params: params
    })
}

// 获取提示语言内容
export function getTipsLangData(params) {
    return request({
        url: "/api/system/tips-lang/",
        method: "get",
        params: params
    })
}


/*---------------------------用户相关-----------------------------------*/
// 获取用户列表
export function getUserList(params) {
    return request({
        url: "/api/system/user/",
        method: "get",
        params: params
    })
}
// 删除用户
export function deleteUser(id) {
    return request({
        url: "/api/system/user/" + id + "/",
        method: "delete",
    })
}

// 修改密码
export function changePassword(params) {
    return request({
        url: "/api/system/change-password/",
        method: "post",
        data: params
    })
}

// 创建用户
export function createUser(params) {
    return request({
        url: "/api/system/user/",
        method: "post",
        data: params
    })
}

// 修改用户
export function updateUser(params) {
    return request({
        url: "/api/system/user/" + params.id + "/",
        method: "put",
        data: params
    })
}
/*---------------------------项目相关-----------------------------------*/
// 获取项目列表
export function getProjectList(params) {
    return request({
        url: "/api/project/project/",
        method: "get",
        params: params
    })
}

// 获取项目详情
export function getProject(id) {
    return request({
        url: "/api/project/project/" + id + "/",
        method: "get",
        params: {}
    })
}
// 创建项目
export function createProject(params) {
    return request({
        url: "/api/project/project/",
        method: "post",
        data: params
    })
}
// 修改项目
export function updateProject(params) {
    return request({
        url: "/api/project/project/" + params.id + "/",
        method: "put",
        data: params
    })
}
// 删除项目
export function deleteProject(id) {
    return request({
        url: "/api/project/project/" + id + "/",
        method: "delete",
    })
}

// 获取项目今年、今日、昨日记录数量
export function getProjectRecordCount(params) {
    return request({
        url: "/api/project/project-record-count/",
        method: "get",
        params: params
    })
}

// 获取项目基本信息数量
export function getProjectInfoCount(params) {
    return request({
        url: "/api/project/project-info-count/",
        method: "get",
        params: params
    })
}


/*---------------------------用户项目权限相关-----------------------------------*/
// 获取用户项目权限列表
export function getUserProjectAuthList(params) {
    return request({
        url: "/api/project/user-project-auth/",
        method: "get",
        params: params
    })
}

// 创建用户项目权限
export function createUserProjectAuth(params) {
    return request({
        url: "/api/project/user-project-auth/",
        method: "post",
        data: params
    })
}

// 修改用户项目权限
export function updateUserProjectAuth(params) {
    return request({
        url: "/api/project/user-project-auth/" + params.id + "/",
        method: "put",
        data: params
    })
}

// 删除用户项目权限
export function deleteUserProjectAuth(id) {
    return request({
        url: "/api/project/user-project-auth/" + id + "/",
        method: "delete",
    })
}

/*---------------------------设备相关-----------------------------------*/
// 获取设备列表
export function getDeviceList(params) {
    return request({
        url: "/api/project/device/",
        method: "get",
        params: params
    })
}

// 获取系统设备列表
export function getSystemDeviceList(params) {
    return request({
        url: "/api/project/system-device/",
        method: "get",
        params: params
    })
}

// 创建设备
export function createDevice(params) {
    return request({
        url: "/api/project/device/",
        method: "post",
        data: params
    })
}

// 修改设备
export function updateDevice(params) {
    return request({
        url: "/api/project/device/" + params.id + "/",
        method: "put",
        data: params
    })
}

// 删除设备
export function deleteDevice(id) {
    return request({
        url: "/api/project/device/" + id + "/",
        method: "delete",
    })
}

// 获取设备的在线、离线数量
export function getOnlineDeviceCount(params) {
    return request({
        url: "/api/project/online-device-count/",
        method: "get",
        params: params
    })
}


/*---------------------------通道相关-----------------------------------*/
// 获取通道列表
export function getPipeList(params) {
    return request({
        url: "/api/project/pipe/",
        method: "get",
        params: params
    })
}

// 获取系统通道列表
export function getSystemPipeList(params) {
    return request({
        url: "/api/project/system-pipe/",
        method: "get",
        params: params
    })
}

// 修改通道
export function updatePipe(params) {
    return request({
        url: "/api/project/pipe/" + params.id + "/",
        method: "put",
        data: params
    })
}

/*---------------------------爆破组相关-----------------------------------*/
// 获取爆破组列表
export function getStationGroupList(params) {
    return request({
        url: "/api/project/station-group/",
        method: "get",
        params: params
    })
}

// 获取系统爆破组列表
export function getSystemStationGroupList(params) {
    return request({
        url: "/api/project/system-station-group/",
        method: "get",
        params: params
    })
}

// 创建爆破组
export function createStationGroup(params) {
    return request({
        url: "/api/project/station-group/",
        method: "post",
        data: params
    })
}

// 修改爆破组
export function updateStationGroup(params) {
    return request({
        url: "/api/project/station-group/" + params.id + "/",
        method: "put",
        data: params
    })
}

// 删除爆破组
export function deleteStationGroup(id) {
    return request({
        url: "/api/project/station-group/" + id + "/",
        method: "delete",
    })
}

/*---------------------------测点相关-----------------------------------*/
// 获取测点列表
export function getStationList(params) {
    return request({
        url: "/api/project/station/",
        method: "get",
        params: params
    })
}

// 获取系统测点列表
export function getSystemStationList(params) {
    return request({
        url: "/api/project/system-station/",
        method: "get",
        params: params
    })
}

// 创建测点
export function createStation(params) {
    return request({
        url: "/api/project/station/",
        method: "post",
        data: params
    })
}

// 修改测点
export function updateStation(params) {
    return request({
        url: "/api/project/station/" + params.id + "/",
        method: "put",
        data: params
    })
}

// 删除测点
export function deleteStation(id) {
    return request({
        url: "/api/project/station/" + id + "/",
        method: "delete",
    })
}


/*---------------------------布点图相关-----------------------------------*/
// 获取布点图列表
export function getLocationImageList(params) {
    return request({
        url: "/api/project/location-image/",
        method: "get",
        params: params
    })
}

// 获取布点图详情
export function getLocationImage(id) {
    return request({
        url: "/api/project/location-image/" + id + "/",
        method: "get",
    })
}


// 创建布点图
export function createLocationImage(params) {
    return request({
        url: "/api/project/location-image/",
        method: "post",
        data: params
    })
}

// 修改布点图
export function updateLocationImage(params) {
    return request({
        url: "/api/project/location-image/" + params.id + "/",
        method: "put",
        data: params
    })
}

// 删除布点图
export function deleteLocationImage(id) {
    return request({
        url: "/api/project/location-image/" + id + "/",
        method: "delete",
    })
}

/*---------------------------布点图位置相关-----------------------------------*/
// 获取布点图位置列表
export function getLocationPointList(params) {
    return request({
        url: "/api/project/location-point/",
        method: "get",
        params: params
    })
}


// 创建布点图位置
export function createLocationPoint(params) {
    return request({
        url: "/api/project/location-point/",
        method: "post",
        data: params
    })
}

// 修改布点图位置
export function updateLocationPoint(params) {
    return request({
        url: "/api/project/location-point/" + params.id + "/",
        method: "put",
        data: params
    })
}

// 删除布点图位置
export function deleteLocationPoint(id) {
    return request({
        url: "/api/project/location-point/" + id + "/",
        method: "delete",
    })
}

/*---------------------------记录相关-----------------------------------*/
// 获取记录列表
export function getRecordList(params) {
    return request({
        url: "/api/project/record/",
        method: "get",
        params: params
    })
}

// 获取记录详情
export function getRecordDetail(id) {
    return request({
        url: "/api/project/record/" + id + "/",
        method: "get",
    })
}

// 刷新记录
export function refreshRecord(params) {
    return request({
        url: "/api/project/refresh-record/",
        method: "get",
        params: params
    })
}

// 获取记录波形
export function getRecordChart(params) {
    return request({
        url: "/api/project/record-chart/",
        method: "get",
        params: params
    })
}

// 获取最新记录波形
export function getLatestRecordChart(params) {
    return request({
        url: "/api/project/latest-record-chart/",
        method: "get",
        params: params
    })
}

// 下载记录
export function downloadRecord(params) {
    return request({
        url: "/api/project/download-record/",
        method: "post",
        data: params
    })
}


// 删除记录
export function deleteRecord(id) {
    return request({
        url: "/api/project/record/" + id + "/",
        method: "delete",
    })
}

// 批量删除记录
export function batchDeleteRecord(params) {
    return request({
        url: "/api/project/record/",
        method: "delete",
        data: params
    })
}
// 获取三向分析的数据
export function getAnalyseRecord(params) {
    return request({
        url: "/api/project/get-analyse-record/",
        method: "post",
        data: params
    })
}
// 获取数据数组的分析结果
export function getAnalyseValueList(params) {
    return request({
        url: "/api/project/get-analyse-value-list/",
        method: "post",
        data: params
    })
}


// 记录进行拟合
export function fittingRecord(params) {
    return request({
        url: "/api/project/fitting-record/",
        method: "post",
        data: params
    })
}


// 获取实时数据
export function getRealTimeRecord(params) {
    return request({
        url: "/api/project/get-real-time-record/",
        method: "get",
        params: params
    })
}

/*---------------------------下载记录任务相关-----------------------------------*/
// 获取记录下载任务列表
export function getDownloadRecordTaskList(params) {
    return request({
        url: "/api/project/download-record-task/",
        method: "get",
        params: params
    })
}

// 删除记录下载任务
export function deleteDownloadRecordTask(id) {
    return request({
        url: "/api/project/download-record-task/" + id + "/",
        method: "delete",
    })
}


// 获取记录下载任务数量
export function getDownloadRecordTaskCount(params) {
    return request({
        url: "/api/project/download-record-task-count/",
        method: "get",
        params: params
    })
}

// 下载zip
export function downloadZip(params) {
    return request({
        url: "/api/project/download-zip/",
        method: 'get',
        data: {},
        params: params,
        responseType: 'blob'
    })
}

/*---------------------------联合记录相关-----------------------------------*/
// 获取联合记录列表
export function getRecordGroupList(params) {
    return request({
        url: "/api/project/record-group/",
        method: "get",
        params: params
    })
}

// 删除联合记录
export function deleteRecordGroup(id) {
    return request({
        url: "/api/project/record-group/" + id + "/",
        method: "delete",
    })
}

// 批量删除联合记录
export function batchDeleteRecordGroup(params) {
    return request({
        url: "/api/project/record-group/",
        method: "delete",
        data: params
    })
}

/*---------------------------报告相关-----------------------------------*/
// 获取报告列表
export function getReportList(params) {
    return request({
        url: "/api/project/report/",
        method: "get",
        params: params
    })
}

// 删除报告
export function deleteReport(id) {
    return request({
        url: "/api/project/report/" + id + "/",
        method: "delete",
    })
}

// 批量删除报告
export function batchDeleteReport(params) {
    return request({
        url: "/api/project/report/",
        method: "delete",
        data: params
    })
}

// 手动生成报告
export function createReport(params) {
    return request({
        url: "/api/project/create-report/",
        method: "post",
        data: params
    })
}

/*---------------------------报告模板相关-----------------------------------*/
// 获取报告模板列表
export function getReportTemplateList(params) {
    return request({
        url: "/api/project/report-template/",
        method: "get",
        params: params
    })
}


// 创建报告模板
export function createReportTemplate(params) {
    return request({
        url: "/api/project/report-template/",
        method: "post",
        data: params
    })
}

// 删除报告模板
export function deleteReportTemplate(id) {
    return request({
        url: "/api/project/report-template/" + id + "/",
        method: "delete",
    })
}

// 测试验证报告模板可用性
export function testReportTemplate(params) {
    return request({
        url: "/api/project/test-report-template/",
        method: "get",
        params: params
    })
}

/*---------------------------定时任务相关-----------------------------------*/
// 获取定时任务列表
export function getTimingList(params) {
    return request({
        url: "/api/project/timing/",
        method: "get",
        params: params
    })
}


// 创建定时任务
export function createTiming(params) {
    return request({
        url: "/api/project/timing/",
        method: "post",
        data: params
    })
}

// 修改定时
export function updateTiming(params) {
    return request({
        url: "/api/project/timing/" + params.id + "/",
        method: "put",
        data: params
    })
}

// 删除定时任务
export function deleteTimging(id) {
    return request({
        url: "/api/project/timing/" + id + "/",
        method: "delete",
    })
}


/*---------------------------报警相关-----------------------------------*/
// 获取报警列表
export function getAlarmList(params) {
    return request({
        url: "/api/project/alarm/",
        method: "get",
        params: params
    })
}

// 删除报警
export function deleteAlarm(id) {
    return request({
        url: "/api/project/alarm/" + id + "/",
        method: "delete",
    })
}

// 批量删除报警
export function batchDeleteAlarm(params) {
    return request({
        url: "/api/project/alarm/",
        method: "delete",
        data: params
    })
}


// WEBPACK FOOTER //
// ./src/api/api.js